import { BuildDetailsState } from './types';

export const VISUAL_SLICE_NAME = 'visual/buildDetails';

export const getInitialState = (): BuildDetailsState => ({
  allDiffIds: [],
  haveItemsChanged: false,
});
